// extracted by mini-css-extract-plugin
export var dividerContainer = "_9h-0";
export var line = "_9h-1";